import images from "./images";


const team = [
    {
        id: 1,
        image: images.team1,
        name: "Alex Turner",
        title: "Security Specialist",
        biography: "Alex Turner is a highly skilled Security Specialist with extensive experience in surveillance systems, risk assessment, and security technology. His expertise in CCTV installation, access control, and cybersecurity helps individuals and businesses enhance their safety measures. With a proactive approach and a keen eye for detail, Alex is dedicated to providing top-notch security solutions.",
        contacts: {
            phone: "555-678-9101",
            email: "alex.turner@example.com",
            website: "www.alexturnersecurity.com"
        },
        accounts: {
            facebook: "",
            linkedin: "",
            twitter: "",
            instagram: ""
        },
        experience: [ 
            "Designed and implemented advanced CCTV surveillance systems",
            "Expert in access control and security automation solutions",
            "Conducted risk assessments to enhance property security",
            "Integrated AI-driven analytics for real-time security monitoring",
            "Specialist in cybersecurity and network security protocols"
        ],
        skills: [
            { id: 1, title: "CCTV Installation", progress: 95 },
            { id: 2, title: "Access Control", progress: 90 },
            { id: 3, title: "Cybersecurity", progress: 85 }
        ]
    },
    {
        id: 2,
        image: images.team2,
        name: "Sarah Miller",
        title: "Installation Expert",
        biography: "Sarah Miller is a seasoned Installation Expert with extensive experience in setting up surveillance systems, access control, and security solutions. She specializes in seamless CCTV installation, ensuring optimal camera placement and system efficiency. Her attention to detail and technical expertise make her a trusted professional in the security industry.",
        contacts: {
            phone: "555-123-4567",
            email: "sarah.miller@example.com",
            website: "www.sarahmillersecurity.com"
        },
        accounts: {
            facebook: "",
            linkedin: "",
            twitter: "",
            instagram: ""
        },
        experience: [ 
            "Installed and configured high-performance CCTV systems",
            "Expert in access control system integration",
            "Ensured optimal camera placement for maximum coverage",
            "Trained clients on system operation and maintenance",
            "Specialist in wired and wireless security installations"
        ],
        skills: [
            { id: 1, title: "CCTV Installation", progress: 95 },
            { id: 2, title: "Access Control", progress: 90 },
            { id: 3, title: "System Configuration", progress: 85 }
        ]
    },
    {
        id: 3,
        image: images.team3,
        name: "David Johnson",
        title: "Surveillance Manager",
        biography: "David Johnson is an experienced Surveillance Manager specializing in monitoring and managing security systems for residential and commercial properties. With expertise in CCTV operations, security protocols, and incident response, he ensures round-the-clock protection. His strategic planning and leadership make him an essential asset in the security industry.",
        contacts: {
            phone: "555-987-6543",
            email: "david.johnson@example.com",
            website: "www.davidjohnsonsecurity.com"
        },
        accounts: {
            facebook: "",
            linkedin: "",
            twitter: "",
            instagram: ""
        },
        experience: [ 
            "Managed large-scale CCTV surveillance networks",
            "Developed security protocols for businesses and homes",
            "Analyzed real-time footage to detect security threats",
            "Led security teams in emergency response planning",
            "Integrated AI and analytics for smarter surveillance"
        ],
        skills: [
            { id: 1, title: "CCTV Operations", progress: 95 },
            { id: 2, title: "Security Management", progress: 90 },
            { id: 3, title: "Threat Analysis", progress: 85 }
        ]
    },
    {
        id: 4,
        image: images.team4,
        name: "Emily Brown",
        title: "Support Lead",
        biography: "Emily Brown is a dedicated Support Lead specializing in assisting clients with CCTV systems, security troubleshooting, and technical support. With extensive experience in customer service and security technology, she ensures seamless operations and prompt issue resolution. Her problem-solving skills and in-depth knowledge make her an invaluable resource in the security industry.",
        contacts: {
            phone: "555-456-7890",
            email: "emily.brown@example.com",
            website: "www.emilybrownsecurity.com"
        },
        accounts: {
            facebook: "",
            linkedin: "",
            twitter: "",
            instagram: ""
        },
        experience: [ 
            "Provided expert technical support for CCTV and security systems",
            "Assisted clients with troubleshooting and system configuration",
            "Ensured quick resolution of security system issues",
            "Trained users on CCTV and access control management",
            "Specialized in remote monitoring and support solutions"
        ],
        skills: [
            { id: 1, title: "Technical Support", progress: 95 },
            { id: 2, title: "Troubleshooting", progress: 90 },
            { id: 3, title: "Customer Assistance", progress: 85 }
        ]
    }

];

export default team;